export enum PracticeStepNameEnum {
  AUTH_AND_RELEASES = "authAndReleases",
  PRACTICE_INFORMATION = "practiceInformation",
  TAX = "tax",
  LIABILITY = "liability",
  OFFICES = "offices",
  PRACTICE_AGREEMENT = "practiceAgreement",
}

export enum ProviderStepNameEnum {
  PERSONAL_INFORMATION = "personalInformation",
  CLIENT_FOCUS = "clientFocus",
  AVAILABILITY = "availability",
  QUALIFICATIONS = "qualifications",
  INSURANCE = "insurance",
  SERVICES = "services",
  LOCATIONS = "locations",
  LIABILITY_INSURANCE = "liabilityInsurance",
  DISCLOSURE = "disclosure",
}

export enum StepStatusEnum {
  COMPLETE = "complete",
  READY = "ready",
}

export interface PracticeProfileStep {
  name: PracticeStepNameEnum
  status: StepStatusEnum
  hide?: boolean
}
export interface ProviderProfileStep {
  name: ProviderStepNameEnum
  status: StepStatusEnum
}

export interface ViewModel {
  practiceProfileSteps: PracticeProfileStep[]
  providerProfileSteps: ProviderProfileStep[]
}
